import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[rlFocusMe]'
})
export class FocusMeDirective implements OnInit {

  @Input() set rlFocusMe(focus : boolean){
    if(focus){
      this.focus();
    }
  }

  constructor(private element : ElementRef) { }

  ngOnInit(): void {
    this.focus();
  }
  
  focus(){
    setTimeout(() => {
      this.element.nativeElement.focus();
    }, 0);
  }
}
